<template>
  <div>
    <div class="d-flex flex-column h-100">
      <div>
        <SystemBar ref="system-bar" :queue="true" />
      </div>
      <div class="flex-fill overflow-auto py-5">
        <div class="d-flex align-center mb-5 px-5">
          <Icon
            :width="24"
            class="mr-4"
            :color="'rgba(0,0,0,.54)'"
            :icon="'human-queue'"
          />
          <h3
            :v-html="$t('queue.wait')"
            class="font-weight-bold ma-0"
          ></h3>
        </div>
        <v-alert
          dense
          elevation="0"
          color="light"
          class="text--secondary py-0 px-5"
        >
          <b>{{ $t('queue.busy') }}</b>
          <br>
          {{$t('queue.turn')}}
        </v-alert>
        <div
          v-if="$store.state.queue.position"
          class="text-center px-5"
        >
          <p class="mb-0">
            <small>{{$t('queue.position')}}</small>
          </p>
          <h1 class="display-2">
            {{ $store.state.queue.position }}
          </h1>
        </div>

        <div class="actions ma-5 text-center">
          <v-btn
            class="font-weight-bold os-rounded"
            type="submit"
            rounded
            outlined
            elevation="0"
            color="primary"
            :loading="button.leave.loading"
            :disabled="button.leave.disabled"
            @click="$refs.confirm.toggleConfirm()"
          >
            {{ $t('queue.quitQueue') }}
            <Icon
              :width="20"
              :height="20"
              class="ml-3"
              :color="'rgba(0,0,0,.54)'"
              :icon="'location-exit'"
            />
          </v-btn>
        </div>
        <Advertisement />

        <v-dialog
          v-model="isNotAlive"
          persistent
          overlay-opacity="0"
          max-width="290"
        >
          <v-card>
            <v-card-title>
              <b>{{ $t('queue.message.title') }}</b>
            </v-card-title>
            <v-card-text >
              <span>
                {{ $t(`queue.message.status_${queueItem ? queueItem.status : 0}`) }}
              </span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <!-- 👇 @click="clearQeueuInterval(), $refs['system-bar'].reset()" -->
              <v-btn
                color="primary"
                text
                @click="$refs['system-bar'].reset()"
                class="os-rounded"
              >
                <b>Salir</b>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <Confirm
          ref="confirm"
          :title="$t('queue.confirmModal.title')"
          :detail="$t('queue.confirmModal.detail')"
          :action="$t('queue.confirmModal.action')"
          @confirmHandler="leaveQueue"
        />
      </div>
      <div>
        <OcularSign />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
import MainService from '@/services/MainService'
import CallServices from '@/services/Call'


@Component({
  components: {
    Confirm: () => import(/* webpackPrefetch: true */ '@/components/Confirm.vue'),
    SystemBar: () => import(/* webpackPrefetch: true */ '@/components/SystemBar.vue'),
    OcularSign: () => import(/* webpackPrefetch: true */ '@/components/OcularSign.vue'),
    Advertisement: () => import(/* webpackPrefetch: true */ '@/views/advertisements/Index.vue'),
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  },
  watch: {
    '$store.state.ping.code': async function () {
      this.joinToRoom()
    }
  },
  computed: {
    widget () {
      return this.$store.state.widget.data
    },
    isNotAlive () {
      return !this.$store.state.queue.isAlive
    },
    queueItem () {
      return this.$store.state.queue.data
    }
  }
})
export default class Queue extends Vue {
  data () {
    return {
      button: {
        leave: {
          loading: false,
          disabled: false
        }
      },
      queueStatusInterval: null
    }
  }
  beforeCreate () {
    this.$store.state.queue.isAlive = true
  }

  mounted () {
    this.$socketEvents.connectListen()
    if (this.$route.query.position) {
      this.$store.state.queue.position = this.$route.query.position
    }

    this.$storage.setState(3)
    this.$store.commit('SET_ACTIVE_CALL', true)
    this.$tabsManager.callStarted()

    const sessionId = this.$store.state.storage.room.session.id
    this.$socketEvents.joinToSessionRoom(sessionId)
  }

  playRoomSound = () => {
    const audio = new Audio('/sounds/Small_Vibe_Stinger.mp3')
    audio.volume = 1
    audio.play()
  }

  joinToRoom () {
    this.$storage.setState(4)
    this.playRoomSound()
    this.$router.replace({ path: '/room' })
  }

  toggleLeaveButton () {
    this.button.leave.loading = !this.button.leave.loading
    this.button.leave.disabled = !this.button.leave.disabled
  }

  async leaveQueue (hard = false) {
    this.toggleLeaveButton()

    const session = this.$store.state.storage.room.session
    return CallServices.leaveQueue(session.id)
      .then((response) => {
        const res = response.data

        this.$store.commit('SET_ACTIVE_CALL', false)
        this.$tabsManager.callFinished()
        this.$socketEvents.disconnectListen()

        if (!hard) {
          this.$router.replace({ path: '/thank-you-page', query: { leaveQueue: true } })
        }
      })
      .catch((e) => {
        console.log(e)
      })
      .then(() => {
        this.toggleLeaveButton()
      })
  }
}
</script>
